import { render } from "./DemandTable.vue?vue&type=template&id=6bff1389&scoped=true"
import script from "./DemandTable.vue?vue&type=script&lang=js"
export * from "./DemandTable.vue?vue&type=script&lang=js"

import "./DemandTable.vue?vue&type=style&index=0&id=6bff1389&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bff1389"]])

export default __exports__